import ListChecklistIcon from '@atlaskit/icon/core/list-checklist';
import React from 'react';

export const SvgActionItem = () => (
  <ListChecklistIcon label="" testId="ads-refreshed-icon" />
);
